export default __webpack_public_path__ + "static/media/B4.814e21a1.mp3";